/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description CityMarker
 */

import { Marker } from '@vis.gl/react-mapbox'
import { createAllowedPropsAreEqual } from '@zcode/react-utils'
import type { BoxTuple } from '@zcode/state-type'
import React, { memo } from 'react'
import * as styles from './style'

const areEqual = createAllowedPropsAreEqual()

export interface CityMarkerProps {
  box: BoxTuple
  large: boolean
  lat: number
  lng: number
  name: string
  onClick: (args: { box: BoxTuple; lat: number; lng: number }) => void
  subText: string | 0
}

export const CityMarker = memo(
  ({ box, large, lat, lng, name, onClick, subText }: CityMarkerProps) => {
    const onCityMarkerClick = (event: React.MouseEvent<HTMLElement>) => {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }

      onClick({ box, lat, lng })
    }

    return (
      <Marker draggable={false} latitude={lat} longitude={lng}>
        <div css={styles.outerContainer}>
          <div css={[styles.container]} onClick={onCityMarkerClick} role="presentation">
            <div css={[styles.textContainer, large && styles.textContainerLarge]}>
              <div css={[styles.text, large && styles.textLarge]}>{name}</div>
              {subText && <div css={[styles.subText, large && styles.subTextLarge]}>{subText}</div>}
            </div>
          </div>
        </div>
      </Marker>
    )
  },
  areEqual
)
